const collection = {
    slug: "matthieu-blazy-chanel-direction-designer-study",
    metaTitle:
      "Matthieu BlazyとCHANEL｜マチュー・ブレイジーを徹底解説",
    metaDescription:
      "Matthieu Blazy（マチュー・ブレイジー）がCHANELで何を変えようとしているのかをEnclopedia独自の視点で徹底解説。Bottega Venetaで培った触覚的ラグジュアリー、Raf Simons、Maison Margiela、Célineでの経験を踏まえ、CHANELのツイード、バッグ、クチュール、記号、日常性の再編集を読み解きます。",
    metaKeywords:
      "Matthieu Blazy,マチュー ブレイジー,マチューブレイジー,マチュー・ブレイジー,CHANEL Matthieu Blazy,シャネル マチュー ブレイジー,CHANEL 新ディレクター,CHANEL クリエイティブディレクター,シャネル クリエイティブディレクター,Matthieu Blazy CHANEL,マチュー ブレイジー シャネル,CHANEL 2026 Matthieu Blazy,CHANEL ツイード,CHANEL バッグ,CHANEL クチュール,CHANEL Blazy,Blazy mania,Bottega Veneta Matthieu Blazy,ボッテガヴェネタ マチューブレイジー,レザーデニム,トロンプルイユ,触覚的ラグジュアリー,Enclopedia,アンクロペディア,アーカイブファッション",
    canonicalPath:
      "/archive_collection/matthieu-blazy-chanel-direction-designer-study",
    heroImage:
      "media/archive_fashion/archive29.png",
    heroImageAlt:
      "Matthieu BlazyによるCHANELディレクションを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "29 / MATTHIEU BLAZY AT CHANEL",
    label: "ARCHIVE DESIGNER STUDY",
    title:
      "Matthieu Blazy at CHANEL｜記号化されたメゾンを、もう一度“触れる服”へ戻せるか",
    lead:
      "Matthieu BlazyがCHANELに入ったことは、単なるデザイナー交代ではありません。\n\nCHANELというメゾンは、すでに世界で最も強い記号を持っています。\n\nツイード。\nカメリア。\nキルティング。\nチェーン。\nパール。\nバイカラーシューズ。\nリトルブラックドレス。\n2.55。\nClassic Flap。\nNo.5。\n\nこれほど強い記号を持つブランドに、新しいデザイナーが入るとき、普通なら問いはこうなります。\n\n彼はCHANELらしさを守れるのか。\n彼は新しいCHANELを作れるのか。\n\nしかしEnclopediaでは、問いを少し変えます。\n\nMatthieu Blazyは、強くなりすぎたCHANELの記号を、もう一度“服”へ戻せるのか。\n\nここが核心です。\n\nBottega VenetaでBlazyが行ったのは、ロゴレスなラグジュアリーをさらに静かにすることではありませんでした。\n彼はラグジュアリーを、視覚的な記号から、素材、手触り、重さ、身体との距離へ戻しました。\n\nデニムに見えるレザー。\nタンクトップに見えるレザー。\n普通の服に見えるのに、実物では異常な密度を持つ服。\n\nこの経験を経て、彼はCHANELへ来ました。\n\nCHANELに必要なのは、さらに大きなロゴではない。\nさらに分かりやすいカメリアでもない。\nさらに記号化されたツイードでもない。\n\n必要なのは、ツイードをもう一度“布”として触らせること。\nキルティングをもう一度“身体に沿う構造”として感じさせること。\nチェーンを装飾ではなく、動作の一部に戻すこと。\nバッグをアイコンではなく、持つ道具として再び近づけること。\n\nMatthieu BlazyのCHANELは、派手な革命ではなく、記号の下に埋もれた身体感覚を掘り起こすディレクションとして読むべきです。",
    keywordLine: [
      "matthieu blazy at chanel",
      "chanel direction",
      "tactile luxury",
      "chanel after symbols",
    ],
    thesis:
      "Matthieu BlazyのCHANELにおける核心は、メゾンの記号を壊すことではなく、ツイード、キルティング、バッグ、クチュール、カメリア、チェーンを“見せる記号”から“身体に触れる構造”へ戻す点にあります。",
    whyTitle:
      "なぜCHANELは、Matthieu Blazyを必要としたのか。",
    whyBody:
      "CHANELは、完成されすぎたブランドです。\n\nこれは強みであると同時に、危険でもあります。\n\n誰もがCHANELを知っている。\n誰もがツイードジャケットを知っている。\n誰もがキルティングバッグを知っている。\n誰もがパール、カメリア、チェーン、バイカラーシューズを知っている。\n\nしかし、知りすぎているものは、見えなくなることがあります。\n\n記号として認識されすぎた服は、実際の素材や身体から離れていく。\nツイードは“CHANELっぽい柄”になり、バッグは“資産価値のあるアイコン”になり、カメリアは“分かりやすい装飾”になる。\n\nそこでBlazyです。\n\n彼はBottega Venetaで、ラグジュアリーをロゴではなく触覚へ戻しました。\n見た目ではなく、素材。\n説明ではなく、手触り。\nブランド記号ではなく、実物の密度。\n\nCHANELがBlazyを必要とした理由は、彼が新しい記号を足す人ではなく、強くなりすぎた記号をもう一度身体に近づけられる人だからです。\n\nCHANELの未来は、CHANELらしさを増やすことではないかもしれません。\nCHANELらしさを、一度服の内側へ沈めること。\n\nEnclopediaでは、BlazyのCHANELを“新ディレクターの話題”ではなく、巨大メゾンが視覚記号から触覚的ラグジュアリーへ移行する実験として読み解きます。",
    pillars: [
      {
        number: "01",
        title: "CHANEL AFTER SYMBOLS",
        text:
          "CHANELには十分すぎるほど記号があります。Blazyの課題は記号を増やすことではなく、ツイード、カメリア、キルティング、チェーンをもう一度身体に近い服や道具として再起動することです。",
      },
      {
        number: "02",
        title: "TACTILE DIRECTION",
        text:
          "Bottega Venetaで見せた触覚的ラグジュアリーは、CHANELでも重要になります。見て分かるCHANELから、触れて分かるCHANELへ。ここがBlazyの最大の転換点です。",
      },
      {
        number: "03",
        title: "COUTURE AS REAL LIFE",
        text:
          "BlazyのCHANELクチュールは、夢物語で終わるものではありません。童話性やファンタジーを使いながらも、現実の女性が生きる時間、動作、日常へ接続しようとしています。",
      },
      {
        number: "04",
        title: "ARCHIVE READING",
        text:
          "Blazy初期CHANELは、将来的に重要なアーカイブ領域になる可能性があります。どの記号を残し、どの記号を柔らかくし、どの素材を再定義したかが後から評価軸になります。",
      },
    ],
    readingTitle:
      "ツイード、バッグ、クチュール、童話、触覚、そしてBottega Venetaから読むMatthieu BlazyのCHANEL。",
    readingIntro:
      "Matthieu BlazyのCHANELを理解するには、単に“新しいシャネルらしさ”を探すだけでは足りません。彼が本当に問われているのは、CHANELの記号をどれだけ派手に更新するかではなく、記号の下にある素材、身体、日常、手仕事をどれだけ回復できるかです。Bottega Venetaで彼が行った触覚的ラグジュアリーの実験は、CHANELでより巨大な意味を持ちます。",
    observations: [
      {
        index: "01",
        title:
          "BlazyのCHANELは、“新しさ”よりも“記号の解凍”から始まる",
        text:
          "CHANELほど記号が強いメゾンでは、新しさを出すことは簡単ではありません。\n\nツイードを変えすぎればCHANELではなくなる。\n変えなければ、ただの継承になる。\n\nこの矛盾の中で、Blazyがすべきことは、CHANELの記号を壊すことではありません。\n\n凍りついた記号を解凍することです。\n\nツイードを“シャネルっぽい柄”としてではなく、身体に乗る布として見せる。\nバッグを“資産価値のあるアイコン”としてではなく、手で持つものとして感じさせる。\nカメリアを“ブランドの印”ではなく、素材や表面の変化として扱う。\n\nBlazyのCHANELは、強い記号をさらに強くする方向ではなく、記号を一度やわらかくする方向に価値があります。",
      },
      {
        index: "02",
        title:
          "CHANELに必要なのは、ロゴの革新ではなく触覚の革新である",
        text:
          "現代のラグジュアリーは、視覚的に飽和しています。\n\nロゴ、アイコンバッグ、SNS映え、ショー演出、セレブリティ。\n\nCHANELはそのすべてに強い。\nしかし、強すぎるからこそ、次の革新は視覚だけでは成立しません。\n\nBlazyがBottega Venetaで提示したのは、触覚の革新でした。\n\n見ただけでは分からない。\n触れて初めて分かる。\n普通に見えるのに、素材が異常に高密度。\n\nCHANELにBlazyが入る意味は、ここにあります。\n\nツイードの凹凸。\nキルティングの膨らみ。\nチェーンの重さ。\nバッグの柔らかさ。\nクチュール刺繍の密度。\n\nCHANELの価値を、再び手触りへ戻せるか。\n\nこれがBlazyの最大の仕事です。",
      },
      {
        index: "03",
        title:
          "ツイードは、アイコンではなく“動く布”として再定義されるべきである",
        text:
          "CHANELにおいてツイードは、最も強い記号の一つです。\n\nしかし、ツイードが強い記号になりすぎると、服は身体から離れます。\n\n“シャネルのツイード”として見られる。\n“高級なジャケット”として認識される。\n“定番”として処理される。\n\nBlazyに期待されるのは、この見え方を変えることです。\n\nツイードをもっと軽くするのか。\n柔らかくするのか。\n身体に沿わせるのか。\n崩すのか。\n内側から変えるのか。\n\n重要なのは、ツイードを装飾記号として使うのではなく、動く布として回復させることです。\n\nCoco Chanelがかつて女性の身体を動きやすくしたように、BlazyのCHANELでもツイードは“格式”ではなく“運動”へ戻されるべきです。",
      },
      {
        index: "04",
        title:
          "バッグは、アイコンから“持つ動作”へ戻される",
        text:
          "CHANELのバッグは、すでに非常に強い記号です。\n\n2.55。\nClassic Flap。\nBoy。\nGabrielle。\nキルティング。\nチェーン。\nターンロック。\n\nしかし、記号化されたバッグは、持つ前から意味が決まってしまいます。\n\nCHANELである。\n高価である。\n資産価値がある。\nステータスである。\n\nBlazyがBottega Venetaでバッグに与えたのは、持つ動作への意識でした。\nKalimeroやAndiamoのように、バッグは単に見せるものではなく、身体に沿わせ、手で触り、動きの中で意味を持つものになっていた。\n\nCHANELで彼が問われるのは、新しいIt Bagを作れるかだけではありません。\nCHANELのバッグを、もう一度“持つ経験”へ戻せるかです。",
      },
      {
        index: "05",
        title:
          "キルティングは、表面の記号から身体とのクッションへ戻る可能性がある",
        text:
          "CHANELのキルティングは、バッグの表面として強く記憶されています。\n\nしかしキルティングは、本来、視覚だけのものではありません。\n\n膨らみ。\n柔らかさ。\n保護。\n身体や物との間にできるクッション。\n\nBlazyがCHANELで面白いのは、このキルティングを単なる柄としてではなく、触覚的な構造として扱える可能性です。\n\nBottega Venetaでの彼は、表面をただ美しくするのではなく、素材の厚みや手触りを通じて価値を作っていました。\n\nならばCHANELのキルティングも、単なるアイコンではなく、身体との距離を作る構造として再解釈できる。\n\nこれは、CHANELのバッグだけでなく、服にも広げられる可能性があります。",
      },
      {
        index: "06",
        title:
          "カメリアは、ロゴ的な花ではなく素材変化として扱うべきである",
        text:
          "カメリアはCHANELの象徴です。\n\nしかし象徴であるがゆえに、非常に扱いが難しい。\n\nそのまま使えば、すぐに“CHANELらしい装飾”になります。\n\nBlazyがカメリアを扱うなら、重要なのは花の形を増やすことではありません。\n\n花を素材の変化として扱うこと。\n布の表面に咲くものとして扱うこと。\n刺繍、織り、凹凸、影、質感として扱うこと。\n\nBottega Venetaで彼が素材の錯覚を作ったように、CHANELではカメリアをロゴから触覚へ変えられるかもしれません。\n\n花である前に、布の変化である。\n\nこの方向こそ、BlazyらしいCHANELの可能性です。",
      },
      {
        index: "07",
        title:
          "クチュールは夢ではなく、現実の女性の身体へ接続される",
        text:
          "BlazyのCHANELクチュールでは、ファンタジーが重要な役割を持っています。\n\n童話。\n物語。\n巨大な花。\n本。\n幻想的な空間。\n\nしかし、ここで重要なのは、彼がファンタジーを現実逃避として扱っていないことです。\n\nCHANELのクチュールは、夢を見せるだけではなく、現実の女性が生きる時間と接続する必要がある。\n\n歩く。\n座る。\n移動する。\n働く。\n年齢を重ねる。\n夜に出かける。\n日常の中で自分を保つ。\n\nBlazyのクチュールが面白いのは、ファンタジーを使いながら、最終的には“現実の身体”へ戻ろうとしている点です。\n\nこれは、CHANELの本質にも近い。\nCHANELは本来、女性を現実の中で自由にするための服だったからです。",
      },
      {
        index: "08",
        title:
          "童話性は、CHANELの神話を再編集するための装置である",
        text:
          "CHANELには、すでに神話があります。\n\nCoco Chanelという人物。\nカンボン通り。\n孤児院。\nリトルブラックドレス。\nNo.5。\n恋愛、独立、モダンな女性像。\n\nBlazyが童話を使うことは、単なるファンタジー演出ではありません。\n\nCHANELというメゾンそのものが、すでに巨大な物語だからです。\n\n童話は、事実と神話の間にあります。\n現実ではないが、人間の記憶に深く残る。\n\nBlazyは、CHANELの歴史を年表として扱うのではなく、物語として扱っている。\n\nただし、それは甘い童話ではありません。\n時に暗く、時に奇妙で、時に現実の女性の孤独や独立へ接続する。\n\nEnclopediaでは、この童話性を、CHANELの神話を再編集するための方法として読みます。",
      },
      {
        index: "09",
        title:
          "BlazyのCHANELは、Coco Chanelの“実用性”へ戻る可能性がある",
        text:
          "CHANELは、しばしば装飾やステータスのブランドとして見られます。\n\nしかしCoco Chanelの本質は、単なる装飾ではありません。\n\n女性の身体を動きやすくすること。\nコルセット的な拘束から離れること。\nジャージーを使うこと。\n男性服的な要素を取り入れること。\n日常の中で自由に動ける服を作ること。\n\nつまり、CHANELの原点には実用性があります。\n\nBlazyのデザインも、ここに接続できます。\n\n彼は、日常着を軽く見ません。\nジーンズ、タンクトップ、シャツ、コート、バッグのような日常的なものを、最も深く作り込む。\n\nCHANELで彼が成功するなら、それはCHANELを派手にすることではなく、CHANELをもう一度“生活の中で動ける服”として説得力を持たせることです。",
      },
      {
        index: "10",
        title:
          "Bottega Venetaでの経験は、CHANELでの最大の武器になる",
        text:
          "Bottega VenetaでBlazyが見せたのは、ブランドを静かに強くする方法でした。\n\nロゴに頼らない。\nしかし分かる人には分かる。\n素材に近づくほど価値が見える。\n持つ、触る、着るという行為の中で意味が出る。\n\nこの経験は、CHANELで非常に重要です。\n\nCHANELはBottega Venetaとは逆に、記号が強すぎるブランドです。\n\nだからこそBlazyは、Bottega Venetaで身につけた“触覚への回帰”を、CHANELでは“記号の柔軟化”として使うことができる。\n\nBottega Venetaでの触覚的ラグジュアリーは、CHANELで記号化されたラグジュアリーを再び身体へ戻すための前史なのです。",
      },
      {
        index: "11",
        title:
          "Raf、Margiela、Céline、Calvin Kleinは、CHANELを読むための下地である",
        text:
          "Blazyの過去の経歴は、CHANELでの仕事を読むための下地になります。\n\nRaf Simonsでは、若者文化と構築性。\nMaison Margielaでは、匿名性、裏側、トロンプルイユ。\nCélineでは、静かな女性の日常着。\nCalvin Kleinでは、アメリカン・ワードローブと広告的な記号。\n\nこれらの経験が、CHANELで重なります。\n\nCHANELは、女性の日常着でもあり、強い記号でもあり、クチュールでもあり、バッグビジネスでもあり、神話でもある。\n\nBlazyは、その複数の層を扱える数少ないデザイナーです。\n\n彼は単に美しい服を作るだけではなく、記号、素材、身体、物語を同時に編集する訓練を積んできたのです。",
      },
      {
        index: "12",
        title:
          "CHANELの増収は、Blazyへの期待値が市場にも作用していることを示す",
        text:
          "CHANELは2024年に減収を経験した後、2025年に成長へ戻ったと報じられています。\n\nもちろん、売上回復をBlazy一人の功績と断定するべきではありません。\n\n価格政策、既存顧客、アクセサリー需要、地域別の市場環境、ブランド力など、複数の要因があります。\n\nただし、Blazyのデザインが新規顧客の関心を生んでいることは重要です。\n\nラグジュアリー市場が全体として慎重になる中で、消費者は“なぜ高いのか”への納得を求めています。\n\nBlazyの方向性は、この問いに強い。\n\n素材がある。\n手仕事がある。\n触覚がある。\n日常着に見えるのに、実物の密度がある。\n\nCHANELの回復は、単なる話題性ではなく、触覚的な説得力を持つラグジュアリーへの期待と接続しています。",
      },
      {
        index: "13",
        title:
          "Blazy初期CHANELは、後から最も重要になる可能性がある",
        text:
          "新しいディレクターが巨大メゾンに入った初期は、後から振り返ると非常に重要です。\n\nなぜなら、最初の数シーズンには判断の跡が残るからです。\n\n何を残したか。\n何を弱めたか。\n何を変えたか。\nどのバッグを押し出したか。\nツイードをどう扱ったか。\nクチュールをどの方向へ動かしたか。\nカメリアをどう解釈したか。\nチェーンを装飾として使ったか、構造として使ったか。\n\nBlazy初期CHANELは、将来的に“方向転換の初期記録”として見られる可能性があります。\n\nEnclopediaでこのタイミングに記事化する意味は、まさにそこにあります。\n\n販売され、流通し、市場評価が固まった後ではなく、変化の始まりを読むことに価値があります。",
      },
      {
        index: "14",
        title:
          "Enclopediaが今Blazyを扱う理由は、所有ではなく“これからのCHANELを読む準備”にある",
        text:
          "現時点でEnclopediaがMatthieu Blazy関連のCHANELを所有していなくても、彼をArchiveCollectionで扱う意味はあります。\n\nむしろ、所有前だからこそ読む必要があります。\n\nこれからCHANELの何を見るべきか。\nツイードの何が変わるのか。\nバッグの何が変わるのか。\nクチュールのどこにBlazyらしさが出るのか。\nBottega Veneta時代の触覚的ラグジュアリーは、CHANELでどう翻訳されるのか。\n\nEnclopediaは、服を所有した後に説明するだけの場所ではありません。\n服が市場へ現れる前に、何を見るべきかを準備する場所でもあります。\n\nBlazyのCHANEL記事は、そのための観察ノートです。",
      },
      {
        index: "15",
        title:
          "CHANELを見る視点を、価格やアイコンから“身体との距離”へ移す",
        text:
          "CHANELを語るとき、価格や資産価値、アイコン性ばかりが前に出ることがあります。\n\nしかし、BlazyのCHANELを見るなら、別の視点が必要です。\n\n身体に近いか。\n動きやすいか。\n触りたくなるか。\n記号が硬すぎないか。\nバッグは持つ動作を変えるか。\nツイードは格式ではなく運動になっているか。\nクチュールは夢だけでなく、現実の身体へ戻っているか。\n\nEnclopediaでは、CHANELを単なる高級ブランドとしてではなく、服と身体の距離を変えてきたメゾンとして読む。\n\nBlazyは、その読み方を更新する重要な入口になります。",
      },
    ],
    quote:
      "Matthieu BlazyのCHANELとは、新しい記号を足すことではない。強くなりすぎた記号を、もう一度、布・手触り・身体へ戻す試みです。",
    perspectiveTitle:
      "Enclopediaは、Matthieu BlazyのCHANELを“新任デザイナーの話題”ではなく“記号化されたメゾンを触覚へ戻す実験”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "CHANEL DIRECTION",
        text:
          "BlazyのCHANELを、ツイード、キルティング、バッグ、カメリア、チェーン、クチュールの再編集として読み解きます。",
      },
      {
        number: "02",
        title: "BOTTEGA AS PRELUDE",
        text:
          "Bottega Venetaでのレザー、クラフト、トロンプルイユ、触覚的ラグジュアリーは、CHANELでの記号の柔軟化につながる前史として整理します。",
      },
      {
        number: "03",
        title: "ARCHIVE WATCH",
        text:
          "Blazy初期CHANELは、今後アーカイブ価値が整理されていく領域です。Enclopediaでは所有前から、その変化の見方を記録します。",
      },
    ],
    experienceTitle:
      "Matthieu BlazyのCHANELを読むことは、これからのラグジュアリーを見る準備である。",
    experienceBody:
      "Matthieu BlazyのCHANELは、単なる新体制ではありません。\n\nそれは、視覚記号として完成しすぎたCHANELを、もう一度、素材、手触り、身体、日常、クチュールの現実性へ戻す試みです。\n\nBottega Venetaで彼が行った触覚的ラグジュアリーは、CHANELではより難しい課題になります。\nなぜならCHANELには、すでに強すぎる記号があるからです。\n\nツイード。\nキルティング。\nカメリア。\nチェーン。\nパール。\nバッグ。\nクチュール。\n\nBlazyがこれらをどう扱うかによって、CHANELの次の10年の見え方は大きく変わります。\n\nEnclopediaがこの記事で目指すのは、Blazy関連アイテムの所有や買取を直接促すことではありません。\n\n彼のCHANELを通じて、読者がCHANELを見る視点を、価格、ロゴ、アイコン性から、素材、身体、触覚、記号の再編集へ移すことです。",
    experienceItems: [
      "BlazyのCHANELでは、ツイードが“記号”ではなく“動く布”として扱われているかを見る",
      "キルティングがバッグの表面柄ではなく、身体との距離や柔らかさとして再解釈されているかを見る",
      "チェーンが装飾ではなく、持つ・動く・重さを感じる構造として使われているかを見る",
      "カメリアがロゴ的な花ではなく、刺繍・織り・凹凸・質感として扱われているかを見る",
      "CHANELバッグが新しいIt Bagではなく、身体に近い道具として更新されているかを見る",
      "クチュールが夢物語ではなく、現実の女性の身体や年齢へ接続しているかを見る",
      "Bottega Veneta時代の触覚的ラグジュアリーが、CHANELでどう翻訳されるかを見る",
      "Blazy初期CHANELを、後年のアーカイブ価値が生まれる可能性のある初期記録として見る",
    ],
    archiveItemsTitle:
      "Matthieu BlazyのCHANELを入口に、アーカイブファッションの“記号と触覚”を読む。",
    archiveItemsBody:
      "Enclopediaでは、Matthieu BlazyをCHANELの新任デザイナーとしてではなく、記号化されたラグジュアリーを触覚へ戻す存在として読みます。この記事は、所有アイテムへの導線ではなく、これからのCHANELを観察するための視点を作る記事です。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 02",
        title: "CHANELの価値を相談する",
        productPath:
            "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
            "CHANELのバッグ、ツイード、ジャケット、アクセサリー、Blazy初期のアイテムまで。記号だけでなく、素材・シーズン・状態・今後のアーカイブ性を確認します。",
       },
      {
        label: "RENTAL FOCUS 04",
        title: "Enclopediaでアーカイブファッションを体験する",
        productPath:
          "/",
        productImage: "",
        text:
          "Enclopediaは、服を所有する前に理解し、実際に身体で体験するためのファッションレンタルサービスです。CHANELを見るための視点も、他ブランドのアーカイブ体験へ接続します。",
      },
    ],
    finalCta: {
        title:
          "Matthieu Blazyを読んだら、次はその一着の“触覚的価値”を相談する。",
        body:
          "Matthieu Blazyは、Bottega Veneta、CHANEL、Maison Margielaを通じて、ラグジュアリーをロゴや記号から、素材・触覚・身体感覚へ戻してきたデザイナーです。\nEnclopediaでは、関連アイテムをブランド名だけでなく、時期、シーズン、素材、クラフト、トロンプルイユ、今後のアーカイブ価値まで含めて確認します。\nまずはLINEでタグ・品質表示・全体写真・付属品をお送りください。",
        buttonLabel: "Matthieu Blazy関連アイテムをLINEで相談する",
        buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;